import { render, staticRenderFns } from "./targeting.vue?vue&type=template&id=fac0a4e6&scoped=true&"
import script from "./targeting.vue?vue&type=script&lang=js&"
export * from "./targeting.vue?vue&type=script&lang=js&"
import style0 from "./targeting.vue?vue&type=style&index=0&id=fac0a4e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac0a4e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
